import { Header } from "@/components/landing/Header";
import { HeroBanner } from "@/components/landing/HeroBanner";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { CausesShowcase } from "@/components/landing/CausesShowcase";
import { SpecialBrandActionsCarousel } from "@/components/landing/SpecialBrandActionsCarousel";
import { HomeOffers } from "@/components/landing/HomeOffers";
import { HomeExclusiveCoupons } from "@/components/landing/HomeExclusiveCoupons";
import { HomeBlogSection } from "@/components/landing/HomeBlogSection";
import { HomeSeoLinks } from "@/components/landing/HomeSeoLinks";
import { Footer } from "@/components/landing/Footer";
import { usePageSeo } from "@/hooks/usePageSeo";
import { OrganizationJsonLd, WebSiteJsonLd } from "@/components/seo/JsonLd";

const Index = () => {
  usePageSeo({
    title: "Shopping do Bem | Plataforma de Cashback Solidário",
    description: "Ajude projetos sociais através do Shopping do Bem. O Cashback solidário garante que toda compra vire doação.",
  });

  return (
    <div className="flex min-h-screen flex-col">
      <OrganizationJsonLd />
      <WebSiteJsonLd />
      <Header />
      <main className="flex-1 min-w-0 overflow-x-hidden">
        <HeroBanner />
        <HowItWorks />
        <CausesShowcase />
        <SpecialBrandActionsCarousel />
        <HomeOffers />
        <HomeExclusiveCoupons />
        <HomeBlogSection />
        <HomeSeoLinks />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
